export default {
  API_BASE_HOST: 'https://www.mercedes-benz.com',
  API_BASE_URL: 'https://www.mercedes-benz.com/public-api/v2/f1-season-api',
  API_JSON_HEADER: 'application/ld+json',
  DATA_HYDRA_MEMBER: 'hydra:member',
};
